import React, { useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles((theme) => ({
  root: {
		width: 350,
    //maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
		flexDirection: 'column',
    alignItems: 'center',
		justifyItems: 'center',
    height: 95,
    paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
		marginBottom: theme.spacing(1),
  },
  inputPart: {
		display: 'flex',
		flexDirection: 'column',
    alignItems: 'center',
		justifyItems: 'center',
    //height: 200,
		backgroundColor: theme.palette.background.default,
    width: '100%',
		marginBottom: theme.spacing(1),
  },
	title: {
		marginBottom: 5,
	},
	typography: {
		fontSize: 14,
		fontWeight: 'bold',
	},
	firstPart: {
		width: '90%',
	},
	radioButton : {
		//marginBottom: theme.spacing(4)
	},
	comment: {
		marginBottom: theme.spacing(2),
		width: '80%'
	},
	radioLeft: {
		marginRight: theme.spacing(2),
	},
}));

const StepperCriteres = ({sousCriteres, radioValue, handleSousCritereCurrent, activeStep, setActiveStep}) => {
  const classes = useStyles();
  const theme = useTheme();
  //const [activeStep, setActiveStep] = React.useState(stepActive);
	const maxSteps = sousCriteres.length;
	
	console.log("Rendu")

	useEffect(() => {
		handleSousCritereCurrent(sousCriteres[activeStep].note.toString(), activeStep, "radio");
		//handleSousCritereCurrent(sousCriteres[activeStep].observation, activeStep, "comment");
	})

	/* useEffect(() => {
		if (activeStep === maxSteps) {
			setActiveStep(0)
		}
	}) */

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div className={classes.root}>

      <Paper square elevation={0} className={classes.header}>        
				<Grid item container className={classes.title} direction='row' alignItems='center' justify='space-between' >
					<Grid item className={classes.firstPart}>
						<Box component='p' className={classes.typography}>{sousCriteres[activeStep].description}</Box>
					</Grid>
					{/* <Grid item>
						<Box component='p'>{sousCriteres[activeStep].note}</Box>
					</Grid> */}
				</Grid>
      </Paper>

      <Paper square elevation={0} className={classes.inputPart}>
					<Grid item container className={classes.radioButton} direction='row' alignItems='center' justify='space-around' >
						<RadioGroup className={classes.radioLeft} row aria-label="sous_criteres" name="sous_criteres" value={radioValue} onChange={(e) => handleSousCritereCurrent(e.target.value, activeStep, "radio")}>
							<FormControlLabel value='1' control={<Radio color='secondary' />} label="Oui" className={classes.radioLeft} />
							<FormControlLabel value='0' control={<Radio color='secondary' />} label="Non"  labelPlacement="start"/>
  					</RadioGroup>
					</Grid>
					{/* <Grid item className={classes.comment}>
						<TextField value={commentChange} onChange={(e) => handleSousCritereCurrent(e.target.value, activeStep, "comment")} color='secondary' className={classes.commentInput} fullWidth={true} multiline={true} rows={2} type="text" size='small' id="commentaire" label="Commentaire" variant="outlined" />
					</Grid> */}
      </Paper>

      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="text"
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
						
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            
          </Button>
        }
      />
    </div>
  );
}

export default StepperCriteres;